export enum PostType {
  POST = "post",
  REEL = "reel"
}
